
import { call, put, takeEvery } from 'redux-saga/effects'
import {
    postSegmentList,
} from '../../network/requests'
import {
    getSegmentListSuccess,
    getSegmentListError,
} from './viewSegmentsReducer'

function* getSegmentList(action) {
    try {
        let body = action.payload
        if (!body) {
            body = {}
            body.segmentIds = [];
            body.segmentNameKeywords = []
        }
        const attributes = yield call(postSegmentList, body)
        yield put(getSegmentListSuccess(attributes))
    } catch (e) {
        yield put(getSegmentListError(e))
    }
}

function* viewSegmentsSaga() {
    yield takeEvery('ViewSegments/getSegmentList', getSegmentList)
}

export default viewSegmentsSaga